<header>
  <div class="display-flex display-flex-space-between grid-col-12 flag-bar flag-bar-height">
    <div>
      <img alt="HRSA Data Warehouse" src="assets/images/usa-flag.png" />
      <span class="font-sans-3xs">An official website of the United States government</span>
    </div>
    <a class="font-sans-3xs" href="https://hhs.gov" title="HHS.gov"
      >U.S. Department of <strong>Health &amp; Human Services</strong></a
    >
  </div>
  <div class="header-bar grid-col-12">
    <div class="data-warehouse-image">
      <a rel="home" title="HRSA Data Warehouse" href="https://data.hrsa.gov">
        <img alt="HRSA Data Warehouse" src="assets/images/app-logo.png" />
      </a>
    </div>
  </div>
</header>
